import { module } from 'angular';
import { UiRouterTitleService } from './ui.router-title.service';
import { UiRouterTitleProvider } from './ui.router-title.provider';
import { uiRouterTitleConfig } from './ui-router-title.config';
import { uiRouterTitleRun } from './ui-router-title.run';
import { uiRouterTitleDirective } from './ui-router-title.directive';

export const UiRouterTitleModule = module('app.shared.directives.ui-router-title', [
  'ui.router'
])
  .directive('uiRouterTitle', uiRouterTitleDirective)
  .provider(UiRouterTitleService.name, UiRouterTitleProvider)
  .config(uiRouterTitleConfig)
  .run(uiRouterTitleRun)
  .name;



// WEBPACK FOOTER //
// ./app/shared/directives/ui-router-title/ui-router-title.module.ts